<template>
  <el-dialog
    title="选择考卷"
    :visible.sync="visible"
    width="640px"
    append-to-body=""
    @closed="handleClosed">
    <el-input
      v-model="config.paperName"
      style="margin-bottom: 10px;max-width: 300px;"
      placeholder="请输入考卷名称">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="handleCurrentChange(1)"></el-button>
    </el-input>
    <el-table
      v-loading="loading"
      border
      :data="list"
      @row-click="handleRowClick">
      <el-table-column
        label="考试科目"
        min-width="100"
        prop="subjectName"></el-table-column>
      <el-table-column
        label="考卷名称"
        min-width="280"
        prop="paperName"></el-table-column>
      <el-table-column
        label="答题时间(分钟)"
        min-width="110"
        :formatter="row=> row.examMinutes"
        prop="examMinutes"></el-table-column>
      <el-table-column
        label="考卷总分(分)"
        min-width="100"
        :formatter="row=> row.paperScore"
        prop="paperScore"></el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"></el-pagination>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ExaminationPaperSelectModal',
  components: {},
  props: {
    callback: Function,
    subjectId: { type: [Number, null], default: null }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: { pageNum: 1, pageSize: 10, paperName: '', status: 1 },
      total: 0
    }
  },
  methods: {
    handleClosed() {
      this.config.pageNum = 1
      this.list = []
    },
    handleRowClick(row) {
      this.visible = false
      const { id: paperId, paperName, paperScore, examMinutes } = row
      this.$emit('select', { paperId, paperName, paperScore, examMinutes })
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },

    fetchList() {
      this.loading = true
      this.$$examApi.getexampapers({ ...this.config, subjectId: this.subjectId })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch() {
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
